/** Email history preview modal, relocated from inline <script>. Email HTML + brand come
 * from the #mero-email-data JSON island; guarded to the email page. */
document.addEventListener('DOMContentLoaded', () => {
    if (!document.getElementById('email-view-modal')) return;
    var __d = document.getElementById('mero-email-data');
    var __data = {};
    try { __data = JSON.parse(__d.textContent || '{}'); } catch (_) { __data = {}; }
    const contents = __data.contents || {};

    const modal = document.getElementById('email-view-modal');
    const frame = document.getElementById('email-modal-frame');
    const subject = document.getElementById('email-modal-subject');
    const date = document.getElementById('email-modal-date');
    let lastTrigger = null;
    const brandName = __data.brandName || '';
    const brandLogo = __data.brandLogo || '';

    // Fit the frame to whatever it is actually showing. Runs for every email, and
    // again once late-loading images have settled — an unmeasured logo is the
    // difference between a snug box and a screenful of blank white.
    const fitFrame = () => {
        const doc = frame.contentDocument;
        if (!doc || !doc.body) return;
        // Collapse first: an iframe's own box is its document's viewport, so
        // body.scrollHeight never reports less than the frame's current height and a
        // short email would keep whatever height the frame already had. Zeroing it
        // forces the reflow that makes scrollHeight mean "content". Same synchronous
        // pass, so nothing paints at zero.
        frame.style.height = '0px';
        const contentHeight = Math.max(doc.body.scrollHeight, doc.documentElement.scrollHeight);
        frame.style.height = `${Math.min(Math.max(contentHeight + 2, 260), window.innerHeight - 170)}px`;
    };

    const renderEmailFrame = () => {
        const doc = frame.contentDocument;
        if (!doc || !doc.body || doc.body.dataset.meroEnhanced) return;
        doc.body.dataset.meroEnhanced = 'true';

        // Stored email HTML goes through Tools::sanitizeContent() (Symfony
        // HtmlSanitizer, allowSafeElements) before it ever reaches here, which drops
        // <style>, <head> and every style attribute. So the content NEVER carries its
        // own CSS and the frame would otherwise render it in the browser default
        // serif. Styling it here is the only place left to do it — and there is
        // nothing of the email's own design to conflict with.
        //
        // What the sanitizer does keep is <img> and <table>, so an email that shipped
        // a logo or a table layout still arrives with its own masthead. Only the
        // injected brand/footer chrome is conditional on that; typography and sizing
        // apply to everything.
        const bringsOwnChrome = !!doc.querySelector('table') || !!doc.querySelector('img');

        const style = doc.createElement('style');
        style.textContent = `
            * { box-sizing: border-box; }
            html { margin: 0; background: #f4f6fb; }
            body {
                width: 100% !important;
                max-width: 640px !important;
                margin: 0 auto !important;
                padding: 0 42px 36px !important;
                color: #293044 !important;
                background: #ffffff !important;
                font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
                font-size: 15px !important;
                line-height: 1.7 !important;
            }
            .mero-mail-brand {
                min-height: 92px;
                margin: 0 -42px 34px;
                padding: 0 42px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #e8ebf2;
                background: linear-gradient(115deg, #111b42, #0b1330);
            }
            .mero-mail-brand img {
                width: auto;
                max-width: 150px;
                height: 38px;
                object-fit: contain;
                filter: brightness(0) invert(1);
            }
            .mero-mail-brand strong {
                color: #fff;
                font-size: 18px;
                letter-spacing: -.02em;
            }
            .mero-mail-brand span {
                color: #aebcff;
                font-size: 10px;
                font-weight: 700;
                letter-spacing: .12em;
                text-transform: uppercase;
            }
            h1, h2, h3 {
                color: #11172a !important;
                font-family: Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", Arial, sans-serif !important;
                letter-spacing: -.025em !important;
            }
            h1 {
                margin: 0 0 22px !important;
                font-size: 28px !important;
                line-height: 1.2 !important;
            }
            p { margin: 0 0 14px !important; }
            a { color: #5271ff !important; font-weight: 600; text-underline-offset: 3px; }
            a.mero-mail-cta {
                display: inline-block !important;
                margin: 9px 0 21px !important;
                padding: 12px 22px !important;
                border-radius: 9px !important;
                color: #fff !important;
                background: #5271ff !important;
                box-shadow: 0 8px 20px rgba(82,113,255,.24) !important;
                text-decoration: none !important;
            }
            .mero-mail-note {
                margin: 20px 0 !important;
                padding: 14px 16px !important;
                border: 1px solid #dfe4ff !important;
                border-radius: 10px !important;
                color: #4f5870 !important;
                background: #f5f7ff !important;
                font-size: 13px !important;
            }
            .mero-mail-footer {
                margin: 30px -42px -36px;
                padding: 28px 42px 24px;
                border-top: 1px solid #e8ebf2;
                color: #8a93a6;
                background: #fafbfc;
                font-size: 11px;
                line-height: 1.6;
            }
            .mero-mail-footer strong { color: #20283b; }
            .mero-mail-signature {
                margin-top: 24px !important;
                padding-top: 18px !important;
                border-top: 1px solid #e8ebf2 !important;
                color: #596277 !important;
                font-size: 13px !important;
                font-weight: 600 !important;
            }
            img { max-width: 100%; height: auto; }
            table { max-width: 100%; border-collapse: collapse; }
            td, th { padding: 4px 8px; vertical-align: top; }
            ul, ol { margin: 0 0 14px !important; padding-left: 22px !important; }
            li { margin-bottom: 4px !important; }
            @media (max-width: 520px) {
                body { padding-inline: 24px !important; }
                .mero-mail-brand { margin-inline: -24px; padding-inline: 24px; }
                .mero-mail-footer { margin-inline: -24px; padding-inline: 24px; }
                h1 { font-size: 24px !important; }
            }
        `;
        doc.head.appendChild(style);

        if (!bringsOwnChrome) {
        const brand = doc.createElement('div');
        brand.className = 'mero-mail-brand';
        // Built with createElement/textContent rather than innerHTML: brandName is the
        // company name from system settings, which any staff role holding
        // system.update_params can set -- and this renders inside every CLIENT's
        // authenticated session. Interpolated into innerHTML, a name of
        // `<img src=x onerror=...>` executed here, and the CSP cannot stop it because
        // script-src still carries 'unsafe-inline' for the legacy on*= handlers.
        if (brandLogo && /^https?:\/\//i.test(brandLogo)) {
            const logo = doc.createElement('img');
            logo.src = brandLogo;          // property assignment, never markup
            logo.alt = brandName;
            brand.appendChild(logo);
        } else {
            const nameEl = doc.createElement('strong');
            nameEl.textContent = brandName;
            brand.appendChild(nameEl);
        }
        const brandLabel = doc.createElement('span');
        brandLabel.textContent = 'Account notification';
        brand.appendChild(brandLabel);
        doc.body.insertBefore(brand, doc.body.firstChild);

        const links = Array.from(doc.querySelectorAll('a'));
        const primaryLink = links.find((link) => /reset|confirm|verify|activate|pay|view invoice|sign in/i.test(link.textContent || ''));
        if (primaryLink) primaryLink.classList.add('mero-mail-cta');

        Array.from(doc.querySelectorAll('p')).forEach((paragraph) => {
            if (/did not request|ignore this email|expire|security/i.test(paragraph.textContent || '')) {
                paragraph.classList.add('mero-mail-note');
            }
            if (/StableHMS|FOSSBilling|Client Management,\s*Invoicing/i.test(paragraph.textContent || '')) {
                paragraph.textContent = `Regards, ${brandName} team`;
                paragraph.className = 'mero-mail-signature';
            }
        });

        const footer = doc.createElement('div');
        footer.className = 'mero-mail-footer';
        const footerName = doc.createElement('strong');
        footerName.textContent = brandName;
        footer.appendChild(footerName);
        footer.appendChild(doc.createElement('br'));
        footer.appendChild(doc.createTextNode(
            'This is an automated account notification. For assistance, contact our support team through your client dashboard.'
        ));
        doc.body.appendChild(footer);
        }

        requestAnimationFrame(fitFrame);
        // An <img> that has not decoded yet reports zero height, so re-measure once
        // each one resolves.
        Array.from(doc.images).forEach((img) => {
            if (img.complete) return;
            img.addEventListener('load', fitFrame, { once: true });
            img.addEventListener('error', fitFrame, { once: true });
        });
    };

    frame.addEventListener('load', renderEmailFrame);
    window.addEventListener('resize', () => {
        if (modal.classList.contains('is-open')) fitFrame();
    });

    const closeModal = () => {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('ref-email-modal-open');
        frame.srcdoc = '';
        if (lastTrigger) lastTrigger.focus();
    };

    document.querySelectorAll('[data-email-open]').forEach((trigger) => {
        trigger.addEventListener('click', (event) => {
            const id = trigger.dataset.emailId;
            if (!contents[id]) return;
            event.preventDefault();
            lastTrigger = trigger;
            subject.textContent = trigger.dataset.emailSubject || 'Email message';
            date.textContent = trigger.dataset.emailDate || '';
            frame.style.height = '';
            frame.srcdoc = contents[id];
            modal.classList.add('is-open');
            modal.setAttribute('aria-hidden', 'false');
            document.body.classList.add('ref-email-modal-open');
            modal.querySelector('.ref-email-modal-close').focus();
        });
    });

    modal.querySelectorAll('[data-email-close]').forEach((trigger) => {
        trigger.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
    });
});
